<template>
    <div class="field field--search | u-relative u-margin-bottom">
        <form @submit.prevent="checkDomain">
            <div class="product__flex-header">
                <label for="domain-search" class="field__label field__label--search">
                    {{ trans('order.choose-domain') }}
                </label>
            </div>
            <div class="u-flex-end">
                <input
                    v-model="searchString"
                    :placeholder="trans('order.register-domain')"
                    id="domain-search"
                    type="text"
                    ref="search"
                    class="field__input field__input--search"
                />
                <div class="field__search-link">
                    <button :disabled="buttonDisabled" type="submit" class="btn btn--blue btn--search">
                        {{ trans('order.check') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { waitForArrayItems } from 'relapp-helpers';

export default {
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            searchString: '',
            checkingDomain: false
        };
    },
    props: {
        domain: {
            type: String,
            default: null
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    async mounted() {
        if (this.domain) {
            this.searchString = this.domain;
            await waitForArrayItems(this.products);
            this.checkDomain();
        }

        this.autofocus();
    },
    computed: {
        ...mapGetters({
            products: 'products/products'
        }),
        /**
         * Checks whether the button should be disabled or not.
         *
         * @return {boolean}
         */
        buttonDisabled() {
            return this.checkingDomain || !this.products.length;
        }
    },
    watch: {
        /**
         * On update domainname enable check button
         */
        searchString() {
            this.checkingDomain = false;
        }
    },
    methods: {
        ...mapActions({
            checkDomainName: 'domains/check'
        }),

        /**
         * Does a domain check, updates the rows and sanitized the input field.
         */
        checkDomain() {
            this.checkDomainName(this.searchString).then(sanitizedInput => {
                this.searchString = sanitizedInput;
                this.checkingDomain = true;
            });
        },

        /**
         * Put focus on the search-input.
         */
        autofocus() {
            this.$refs.search.focus();
        }
    }
};
</script>
